export default __webpack_public_path__ + "images/pet_in_hold.b57501e.svg";